const year = (new Date).getFullYear();

const constants = {

    /** Hero Section */
    user_name: "Poojan Bhatt",
    hire_me_button: "Linkedin",
    resume_button: "Get Resume",
    nav_menu: {
        home: " Home",
        about: " About",
        projects: " Projects",
        resume: " Resume",
        blogs: " Blogs"
    },
    profile_image_url: "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
    resume_url: "https://drive.google.com/file/d/1_X4JYKlMil8gn8GL5PkyP6d3f6y_3GK5/view?usp=sharing",
    linkedin_url: "https://www.linkedin.com/in/poojan-bhatt-8b7612187/",
    animation_strings: [
        'Entusiastic dev 😎',
        'Mobile App Developer',
    ],
    tag_line: "I like to build mobile apps that solve every-day problems.",




    /** About Me Section */
    about_me_text: "I am a Software Engineer. I enjoy solving complex problems and I am always ready to learn and improve. I have 1 year of experience as a Mobile Application developer. I enjoy building out efficient and user-friendly applications",
    about_section_header: "About  Me",
    about_section_subheader: "Why choose Me?",
    highlights_header: "Here are Few Highlights",
    about_highlights: [
        "Cross-Platform App development",
        "Interactive Front end as per design",
        "Front End : React, React Native, Redux ",
        "Backend/Db : Firebase, Node Js, Sql, Mongo Db",
        "Languages : Javascript, C++",
    ],




    /** Resume Section */
    resume_section_header: "Resume",
    resume_section_subheader: "My formal Bio Details",
    resume_education_section: "Education",
    resume_work_section: "Work",
    resume_programming_section: "Programming",
    resume_projects_section: "Projects",

    tech_stack_str: "Tech Stack :",

    work_details: [
        {
            name: "Bacancy Technology",
            duration: "2021-Present",
            position: "Software Developer",
            description: [
                "I am responsible for designing, building and maintaining efficient and user-friendly mobile applications.",
                "I am working on the project which requires maintenance of existing application where I deliver new features according to client needs and i make sure that user gets the seem less experience.",
                "I have worked on many modules like handling notification re directions, deep linking, UI development, Accessing native modules(location, gallery, contacts, calendar etc..)"
            ]
        }
    ],

    project_details: [
        {
            name: "Chat Application",
            tech: "React native, Redux, Typescript, Firebase",
            descr: [
                "An interface which makes it easy to communicate with people anywhere in the world by sending and receiving messages in real time.",
                "React Native is used for building user interactive interface that is responsible for rendering the list of users and enhanced chat room.",
                "Firebase Real time database is used for Receiving and Sending the messages that reflects on application real time."
            ],
        },
        {
            name: "Real Time Sharing White board",
            tech: "React Js, Node Js",
            descr: [
                "An interface where user can share his White-board and make changes to the white board and this changes are made visible to other users.",
                "To develop the user interface I have used React Js and Bootstrap. To draw graphics on White board I have used Rough Js library.",
                "I have used Node Js for Back end service and to reflect real time changes of the white board I have used Socket.IO library."
            ],
        },
    ],

    education_details: [
        {
            institue: 'Vishwakarma Goverment Engineering College',
            degree: 'Bachelors in Computer Engineering',
            duration: '2017-2021'
        },
        {
            institue: 'Diwan Ballubhai Higher Secondary School',
            degree: '12th Boards',
            duration: '2017'
        },
        {
            institue: 'Diwan Ballubhai Secondary School',
            degree: '10th Board',
            duration: '2015'
        }
    ],

    skill_details: [
        { name: "Javascript", percentage: 80 },
        { name: "Typescript", percentage: 80 },
        { name: "C++", percentage: 80 },
        { name: "Python", percentage: 80 },
        { name: "Java", percentage: 80 },
    ],




    /**Coding Profiles Section */
    coding_profile_section_header: "Coding Profiles",
    coding_profile_section_subheader: "Checkout my coding profiles",
    profile_github: "Github",
    profile_leetcode: "Leetcode",
    profile_codechef: "Codechef",

    github_url: "https://github.com/poojan010",
    leetcode_url: "https://leetcode.com/poojan010/",
    codechef_url: "https://www.codechef.com/users/poojan_bhatt",

    /** Contact section */
    contact_section_header: "Contact Me",
    contact_section_subheader: "Let's keep in touch.",
    contact_card_title: "Get in touch",

    input_title_name: "Name",
    input_title_email: "Email",
    input_title_message: "Message",

    input_placeholder_name: "Enter your name",
    input_placeholder_email: "Enter your email",
    input_placeholder_message: "Enter your message",

    form_submit_button: "Send Message",


    SERVICE_ID: "",
    TEMPLATE_ID: "",
    USER_ID: "",


    nameRequired: "Name is Required",
    emailRequired: "Email is Required",
    messageRequired: "Message is Required",

    invalidEmail: "Email is Invalid",



    footerLeftTitle: "Designed and Developed by Poojan Bhatt",
    footerMiddleTitle: `Copyright © ${year} PB`,


    hiThere: "Hi There! ",
    imStrong: "I'M",
    nameStrong: " POOJAN BHATT",


    softwareDev: "Software Engineer",
    rnDev: "React native developer",
    enthusiaticDev: "Entusiastic dev",
    openSourceDev: "Open Source Contributor",


    letMe: "LET ME ",
    introduce: " INTRODUCE",
    mySelf: " MYSELF",

    fellFree: "Feel free to",
    connect: " connect",
    withMeOn: " with me on"
}

export default constants

